const regex = /[A-Z]+[0-9]+:([A-Z]+)([0-9]+)/;

export function getWorkSheetHeight(range) {
  const result = regex.exec(range);
  const [, , height] = result;
  return height;
}

export function getWorkSheetWidth(range) {
  const result = regex.exec(range);
  const [, width] = result;
  return width;
}
